import React, { Component } from 'react';

import './css/Header.css';
import StringUtils from "../../utils/StringUtils";

class Header extends Component {
    render() {
        return (
            <div className="header">
                <div className="header-title">{StringUtils.parse(this.props.header)}</div>
                <div className="header-description">{StringUtils.parse(this.props.description)}</div>
            </div>
        )
    }
}

export default Header;